import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import momentRange from 'moment-range';
import moment from 'moment-timezone';

import { TimeFrame } from 'app/shared/model/charts/time-frame.model';

import { TimeFrameLabelValues } from '../model/charts/time-frame-label-values.model';
import { TimeFrameLabels } from '../model/charts/time-frame-labels.enum';

// The require()-based block is for browsers, the import-based is for tests execution
const { extendMoment } = typeof require === 'function' ? require('moment-range') : momentRange;

const { range } = extendMoment(moment as any);

@Injectable({ providedIn: 'root' })
export class DateRangeService {
  private readonly ranges: TimeFrame[] = [
    {
      label: TimeFrameLabels.AllTime,
      value: TimeFrameLabelValues[TimeFrameLabels.AllTime],
      range: range(),
    },
    {
      label: TimeFrameLabels.CurrentWeek,
      value: TimeFrameLabelValues[TimeFrameLabels.CurrentWeek],
      range: range(moment().startOf('week'), moment().endOf('week')),
    },
    {
      label: TimeFrameLabels.CurrentMonth,
      value: TimeFrameLabelValues[TimeFrameLabels.CurrentMonth],
      range: range(moment().startOf('month'), moment().endOf('month')),
    },
    {
      label: TimeFrameLabels.CurrentQuarter,
      value: TimeFrameLabelValues[TimeFrameLabels.CurrentQuarter],
      range: range(moment().startOf('quarter'), moment().endOf('quarter')),
    },
    {
      label: TimeFrameLabels.CurrentYear,
      value: TimeFrameLabelValues[TimeFrameLabels.CurrentYear],
      range: range(moment().startOf('year'), moment().endOf('year')),
    },
    {
      label: TimeFrameLabels.LastWeek,
      value: TimeFrameLabelValues[TimeFrameLabels.LastWeek],
      range: range(moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')),
    },
    {
      label: TimeFrameLabels.LastMonth,
      value: TimeFrameLabelValues[TimeFrameLabels.LastMonth],
      range: range(
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ),
    },
    {
      label: TimeFrameLabels.LastQuarter,
      value: TimeFrameLabelValues[TimeFrameLabels.LastQuarter],
      range: range(
        moment().subtract(1, 'quarter').startOf('quarter'),
        moment().subtract(1, 'quarter').endOf('quarter'),
      ),
    },
    {
      label: TimeFrameLabels.LastYear,
      value: TimeFrameLabelValues[TimeFrameLabels.LastYear],
      range: range(moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')),
    },
  ];

  getRanges() {
    return cloneDeep(this.ranges);
  }

  getCustomRange(): TimeFrame {
    return {
      label: TimeFrameLabels.Custom,
      value: TimeFrameLabelValues[TimeFrameLabels.Custom],
    };
  }
}
